import { http } from '../../http';

export default {
  getDateArticles(params = {}, filter = {}) {
    return http.get('/dates/calendar', {
      params: {
        per_page: params.per_page || 5,
        page: params.page || 1,
        category: filter?.category,
        start_day: filter?.start_day,
        start_month: filter?.start_month,
        end_day: filter?.end_day,
        end_month: filter?.end_month,
      },
    });
  },

  getDateArticlesBySlug(slug) {
    return http.get(`/dates/${slug}`);
  },

  getDatesCategories() {
    return http.get('/dates/calendar/categories');
  },
};
